@if (label || switched || headerControl.length) {
    <div class="header">
        @if (headerControl.length) {
            <div class="header-controls before"
                 #before [ngClass]="{'empty': before.children.length === 0}">
                <ng-content select="fui-content-layout-header-control[slot=before]"></ng-content>
            </div>
        }
        @if (label) {
            <div class="header-label">
                <div class="header-label-title">
                    {{ label | translate: i18nParams }}
                </div>
            </div>
        }
        @if (switched || headerControl.length) {
            <div class="header-controls after"
                 #after [ngClass]="{'empty': !switched && after.children.length === 0}">
                @if (switched) {
                    <fui-switch-control [(ngModel)]="enabled" label="''"></fui-switch-control>
                }
                <ng-content select="fui-content-layout-header-control[slot=after]"></ng-content>
            </div>
        }
    </div>
}
@if (!switched || enabled) {
    <div class="main">
        <ng-content></ng-content>
    </div>
}
